// extracted by mini-css-extract-plugin
module.exports = {"root":"Nav_root__o9yYD","logo":"Nav_logo__DLlLt","links":"Nav_links__gP1Rz","link":"Nav_link__8Jtyx","activeLink":"Nav_activeLink__28ehC"};